import MojitoCore from 'mojito/core';
import MojitoApplications from 'mojito/applications';

import {stripRoutingPrefix} from '#core/utils/url-utils.js';
import {isValidIntent, openInternalIntent} from '#core/utils/intent-utils.js';

import {isInternalUrl} from '#core/application/utils.js';
import {ApplicationConfig} from '#core/config/application-config.js';

import {apiLog, wrapExternal} from './utils.js';

const IntentActions = MojitoCore.Intents.actions;
const reduxInstance = MojitoCore.Services.redux;
const {dispatch} = MojitoCore.Services.redux.store;
const {selectors: routerSelectors, actions: routerActions} = MojitoApplications.Common.Router;

let internalRouteListener = null;
reduxInstance.actionListener.startListening({
    actionCreator: routerActions.routeChange,
    effect: data => {
        if (isInternalUrl(data.payload) && internalRouteListener) {
            internalRouteListener(data.payload);
        }
    },
});

export function setInternalRouteListener(val) {
    internalRouteListener = wrapExternal(val);
}

export function navigate(state, method, ...params) {
    let intent;
    apiLog.debug('navigate', method, ...params);

    if (!state.containerNode) {
        apiLog.warn(`Cannot navigate. ${PRODUCT_NAME} is not mounted`);
        return false;
    }

    if (!method) {
        // Sync router store with current history location path.
        // This is needed for a cases when navigation is done outside lotto.
        const pathChanged = window.location.pathname !== routerSelectors.selectRoute();
        if (pathChanged) {
            dispatch(routerActions.routeChange(window.location.pathname));
        }
        return true;
    }

    if (method === stripRoutingPrefix(ApplicationConfig.initParams.routingPrefix, window.location.pathname)) {
        method = method.substring(1);
        intent = openInternalIntent('toCustom', [method]);
        intent.data.isRedirect = true;
    } else if (method === '/') {
        intent = openInternalIntent('toHome');
    } else if (method[0] === '/') {
        method = method.substring(1); // delete leading slash (moj specific)
        intent = openInternalIntent('toCustom', [method]);
    } else {
        intent = openInternalIntent(method, params);
    }

    if (isValidIntent(intent)) {
        dispatch(IntentActions.publishIntent(intent.type, intent.data));
        return true;
    }

    return false;
}
